<template>
   <div>
      <button
         class="btn btn-primary btn-sm btn-block mb-2"
         @click="visible = true"
      >history</button>
      <b-modal v-model="visible" size="xl" centered hide-footer hide-header>
         <b-pagination
            v-if="(materialHistories.length > perPage) && (!loading)"
            id="table-pagination-material-histories"
            class="float-right"
            v-model="currentPage"
            :total-rows="materialHistories.length"
            :per-page="perPage"
            aria-controls="table-material-histories"
         ></b-pagination>
         <b-table
            v-if="!loading"
            id="table-material-histories"
            :items="materialHistories"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            striped hover
         >
            <template v-slot:cell(typeandid)="row">
               <span>{{row.item.type_humanReadable}}</span>
               <span v-if="row.item.typeId_humanReadable"><b>#</b>{{row.item.typeId_humanReadable}}</span>
            </template>
            <template v-slot:cell(diff)="row">
               <div v-for="x in row.item.formattedDiffs" :key="x">
                  <b-badge v-if="x == 'History Eintrag nicht lesbar!'" variant="danger">History Eintrag nicht lesbar!</b-badge>
                  <span v-else>{{x}}</span>
                  <br>
               </div>
            </template>
         </b-table>
         <div v-if="loading" class="text-center justify-content-between">
            <b-spinner/>
         </div>
      </b-modal>
   </div>
</template>
<script>
export default {
   name: "MaterialHistoryComponent",
   props: [ "materialId" ],
   data() {
      return {
         loading: false,
         initialLoad: false,
         mdsRegions: [],
         mdsCountries: [],
         mdsMarkets: [],
         currentPage: 1,
         perPage: 10,
         visible: false,
         materialHistories: [],
         fields: [
            //{ key: "reason", label: "Grund" },
            { key: "created_at", label: "Datum", formatter: s => moment(s).format("DD.MM.YYYY HH:mm") },
            { key: "user", label: "User", formatter: u => u.name },
            { key: "typeandid", label: "Type#ID" },
            { key: "diff", label: "Change" }
         ],
         flags: {
            FSK_18: 1,
            DHL_KLEINPAKET: 2, //Sendungsart
            BULKY_GOOD: 8,
            AMIIBO: 256, //Versandaufschlag
            SKYLANDERS: 512,
            FUNKO: 1024,
            KITCHEN: 2048,
            CALENDAR: 4096,
            PARROT: 8192,
            VINYL: 4, //Sonstige
            VENDOR_WEIGHT_AMBIGUOUS: 32,
            NINTENDO_GAME: 16384,
            LITHIUM_BATTERY: 32768,
            CLAIREFONTAINE: 262144,
            TPLINK: 524288,
            MOLESKINE: 1048576,
            NETGEAR: 2097152,
            PALADONE: 4194304,
            CATEGORY_MANUALLY_SET: 16777216, //25
         }
      };
   },
   methods: {
      diffFormatter(w) {
         let ret = [];
         let v = {};
         try {
            v = JSON.parse(w);
         }
         catch(error)
         {
            return ["History Eintrag nicht lesbar!"]
         }
         for (let k of Object.keys(v.new))
         {
            var str = "";
            switch (k) {
               case "isBlocked":
                  v.old[k] = v.old[k] == "1" ? "gesperrt" : "entsperrt";
                  v.new[k] = v.new[k] == "1" ? "gesperrt" : "entsperrt";
                  break;
               case "purchasePrice":
                  v.old[k] = parseFloat(v.old[k]).toFixed(2) + "€";
                  v.new[k] = parseFloat(v.new[k]).toFixed(2) + "€";
                  break;
               case "length":
               case "width":
               case "height":
                  v.old[k] += " cm";
                  v.new[k] += " cm";
                  break;
               case "extraWeightCharge":
               case "manualWeight":
               case "volumeWeight":
                  v.old[k] = parseFloat(v.old[k]) / 1000 + " kg";
                  v.new[k] = parseFloat(v.new[k]) / 1000 + " kg";
                  break;
            }

            if (k == "flags") {
               for (let f in this.flags) {
                  if (this.flags[f] & (v.old[k] ^ v.new[k])) {
                     const state = ((v.old[k] ^ v.new[k]) & v.new[k]) != 0 ? "gesetzt" : "entfernt";
                     str += `${f} ⟶ ${state},`;
                  }
               }
            } else if (k == "isBlocked" || k == "needsMetaData") {
               str += k + ": " + v.new[k];
            } else if (k == "blockerManual") {
               try {
                  for (let newBlockerManuals of v.new["blockerManual"]) {
                  str += Object.keys(newBlockerManuals)[0];
                  }
               } catch (error) {
                  //This try catch block might be a really stupid idea... but it works. Ultra botch!
                  let type =
                  v.old.blockerManual.blackOrWhite == 1 ? "Sperrung " : "Freigabe ";
                  if (v.old.blockerManual.countryId) {
                  type +=
                     "(Land): " +
                     this.mdsCountries.find(
                        (country) => country.id == v.old.blockerManual.countryId
                     ).iso;
                  } else if (v.old.blockerManual.marketId) {
                  type +=
                     "(Markt): " +
                     this.mdsMarkets.find(
                        (market) => market.id == v.old.blockerManual.marketId
                     ).name;
                  } else if (v.old.blockerManual.regionId) {
                     type +=
                        "(Region): " +
                        this.mdsRegions.find(
                           (region) => region.id == v.old.blockerManual.regionId
                        ).name;
                  } else {
                     type += "(FEHLER): ";
                  }
                  str += `BlockerManual ${type}, ursprünglicher Grund: »${v.old.blockerManual.reason}« ⟶ gelöscht`;
               }
            } else {
               str += `${k}: ${v.old[k]} ⟶ ${v.new[k]}`;
            }
            ret.push(str);
         }
         return ret;
      },
      loadData() {
         this.loading = true;
         if(this.initialLoad) {
            axios.get(`/material/${this.materialId}/history`)
            .then( _history => {
               this.materialHistories = _history.data.map( entry => {
                  entry.formattedDiffs = this.diffFormatter(entry.diff);
                  return entry;
               });
               this.loading = false;
            }).catch( error => {
               this.$bvToast.toast("Konnte Material history Einträge nicht holen.", {
                  title: "Material History",
                  autoHideDelay: 7500,
                  appendToast: false,
                  variant: "danger",
               });
               console.error(error);
               this.loading = false;
            });
         } else {
            Promise.all([
               axios.get(`/material/${this.materialId}/history`),
               axios.get("/mds/country"),
               axios.get("/mds/market"),
               axios.get("/mds/region"),
            ]).then( ([_history, _country, _market, _region]) => {
               this.mdsCountries = _country.data;
               this.mdsMarkets = _market.data;
               this.mdsRegions = _region.data;
               this.materialHistories = _history.data.map( entry => {
                  entry.formattedDiffs = this.diffFormatter(entry.diff);
                  return entry;
               });
               this.loading = false;
               this.initialLoad = true;
            }).catch( error => {
               this.$bvToast.toast("Konnte Material history Einträge nicht holen.", {
                  title: "Material History",
                  autoHideDelay: 7500,
                  appendToast: false,
                  variant: "danger",
               });
               console.error(error);
               this.loading = false;
            });
         }
      }
   },
   watch: {
      visible: function(n,o) {
         if(n) this.loadData();
      }
   },
   created() {
      // this.loadData();
   },
};
</script>
